(function () {
  // --------------------------------------------------
  // OPPREF
  // Capture this FIRST, even if tracking was already installed
  // --------------------------------------------------

  function readOpprefFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get("oppref");
    } catch (e) {
      return null;
    }
  }

  function readOpprefFromCookie() {
    try {
      const match = document.cookie.match(/(?:^|;\s*)__oppref=([^;]+)/);

      if (match && match[1]) {
        return decodeURIComponent(match[1]);
      }
    } catch (e) {
      console.warn("[OpenAI] Could not read __oppref cookie", e);
    }

    return null;
  }

  function syncOpprefToStorage() {
    try {
      const fromUrl = readOpprefFromUrl();

      if (fromUrl) {
        localStorage.setItem("openai_oppref", fromUrl);
        console.log("[OpenAI] oppref captured from URL:", fromUrl);
        return fromUrl;
      }

      const stored = localStorage.getItem("openai_oppref");

      if (stored) {
        console.log("[OpenAI] oppref loaded from storage:", stored);
        return stored;
      }

      const fromCookie = readOpprefFromCookie();

      if (fromCookie) {
        localStorage.setItem("openai_oppref", fromCookie);
        console.log("[OpenAI] oppref captured from cookie:", fromCookie);
        return fromCookie;
      }
    } catch (e) {
      console.warn("[OpenAI] oppref storage error", e);
    }

    return null;
  }

  const currentOppref = syncOpprefToStorage();

  async function saveOpprefToShopifyCart() {
    const oppref =
      readOpprefFromUrl() ||
      currentOppref ||
      localStorage.getItem("openai_oppref") ||
      readOpprefFromCookie();

    if (!oppref) {
      console.log("[OpenAI] No oppref available");
      return;
    }

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            openai_oppref: oppref
          }
        })
      });

      if (response.ok) {
        console.log("[OpenAI] oppref saved to Shopify cart:", oppref);
      } else {
        console.warn(
          "[OpenAI] Failed to save oppref to Shopify cart:",
          response.status
        );
      }
    } catch (e) {
      console.warn("[OpenAI] Shopify cart oppref error", e);
    }
  }

  // Even if another copy already installed tracking,
  // still persist oppref before returning.
  if (window.__daleburyOpenAITrackingInstalled) {
    saveOpprefToShopifyCart();
    return;
  }

  window.__daleburyOpenAITrackingInstalled = true;

  let lastAddToCartAt = 0;

  // --------------------------------------------------
  // OPENAI PIXEL READY
  // --------------------------------------------------

  function whenOaiReady(callback, attempts = 20) {
    if (typeof window.oaiq === "function") {
      callback();
      return;
    }

    if (attempts <= 0) return;

    setTimeout(function () {
      whenOaiReady(callback, attempts - 1);
    }, 250);
  }

  // --------------------------------------------------
  // PAGE VIEW
  // --------------------------------------------------

  function trackPageViewed() {
    window.oaiq(
      "measure",
      "page_viewed",
      { type: "contents" }
    );
  }

  // --------------------------------------------------
  // ADD TO CART
  // --------------------------------------------------

  function trackAddToCart() {
    const now = Date.now();

    if (now - lastAddToCartAt < 2000) {
      console.log("[OpenAI] Duplicate items_added blocked");
      return;
    }

    lastAddToCartAt = now;

    window.oaiq(
      "measure",
      "items_added",
      { type: "contents" }
    );

    console.log("[OpenAI] items_added sent");
  }

  // --------------------------------------------------
  // INITIAL LOAD
  // --------------------------------------------------

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      whenOaiReady(trackPageViewed);
      saveOpprefToShopifyCart();
    });
  } else {
    whenOaiReady(trackPageViewed);
    saveOpprefToShopifyCart();
  }

  // --------------------------------------------------
  // SHOPIFY FETCH HOOK
  // --------------------------------------------------

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url =
        typeof args[0] === "string"
          ? args[0]
          : args[0] && args[0].url
          ? args[0].url
          : "";

      const isCartAdd =
        url.includes("/cart/add") ||
        url.includes("/cart/add.js");

      if (response.ok && isCartAdd) {
        whenOaiReady(trackAddToCart);
        saveOpprefToShopifyCart();
      }
    } catch (e) {
      console.warn("[OpenAI] ATC tracking error", e);
    }

    return response;
  };
})();